export default {
    'entryMap': {
        'default': [
            'button',
            'button-group',
            'collapse',
            'icon',
            'radio',
            'radio-group',
            'checkbox',
            'checkbox-group',
            'divider',
            'modal',
            'radio-modal',
            'checkbox-modal',
            'tip',
            'toast',
            'popup',
            'dialog',
            'picker',
            'picker-popup',
            'picker-modal',
            'cascade-picker',
            'cascade-picker-popup',
            'cascade-picker-modal',
            'date-picker',
            'date-picker-popup',
            'date-picker-modal',
            'time-picker',
            'time-picker-popup',
            'time-picker-modal',
            'segment-picker',
            'textarea',
            'float-ball',
            'input',
            'tab-bar',
            'swipe'
        ],
        introduce: [
            {
                name: '基础',
                components: [
                    'button',
                    'button-group',
                    'icon',
                    'divider',
                    'float-ball',
                    'loading',
                    'collapse',
                    'swipe',
                    'sticky',
                    'tab-bar'
                ]
            },
            {
                name: '表单',
                components: [
                    'checkbox',
                    'checkbox-group',
                    'radio',
                    'radio-group',
                    'input',
                    'textarea',
                    'picker',
                    'cascade-picker',
                    'date-picker',
                    'time-picker',
                    'rate',
                    'switch',
                    'slider'
                ]
            },
            {
                name: '弹出层',
                components: [
                    'popup',
                    'toast',
                    'dialog',
                    'modal',
                    'tip',
                    'action-sheet'
                ]
            },
            {
                name: '组合组件',
                components: [
                    'radio-modal',
                    'checkbox-modal',
                    'picker-modal',
                    'cascade-picker-modal',
                    'date-picker-modal',
                    'time-picker-modal',
                    'picker-popup',
                    'cascade-picker-popup',
                    'date-picker-popup',
                    'time-picker-popup',
                    'scroll-nav-bar'
                ]
            }
        ],
        // 'driver': [
        //   'button',
        //   'button-group',
        //   'icon',
        //   'radio',
        //   'radio-group',
        //   'radio-modal',
        //   'checkbox',
        //   'checkbox-group',
        //   'divider',
        //   'modal',
        //   'tip',
        //   'toast',
        //   'popup',
        //   'dialog',
        //   'picker',
        //   'picker-popup',
        //   'cascade-picker',
        //   'cascade-picker-popup',
        //   'date-picker',
        //   'date-picker-popup',
        //   'time-picker',
        //   'time-picker-popup',
        //   'segment-picker',
        //   'textarea',
        //   'float-ball'
        // ],
        // 'passenger': [
        //   'button',
        //   'button-group',
        //   'icon',
        //   'radio',
        //   'radio-group',
        //   'checkbox',
        //   'checkbox-group',
        //   'modal',
        //   'radio-modal',
        //   'checkbox-modal',
        //   'dialog',
        //   'toast',
        //   'picker',
        //   'picker-modal',
        //   'cascade-picker',
        //   'cascade-picker-modal',
        //   'date-picker',
        //   'date-picker-modal',
        //   'time-picker',
        //   'time-picker-modal',
        //   'segment-picker',
        //   'textarea',
        //   'float-ball'
        // ]
    }
};
